import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GlobalStyles } from '../utils/global'
import CookieConsent from "react-cookie-consent";
import { FirebaseContext, useAuth } from './Firebase'
import { ThemeProvider } from 'styled-components'
import { Theme } from '../utils/theme'
import Feedback from './Feedback'
import styled from 'styled-components';

import Header from "./header"
import Footer from "./footer"

const Section = styled.div`
  display:grid;
  place-content:center;
  margin:5rem auto;
`

const Layout = ({ children }) => {
  const { user, firebase, loading } = useAuth();
  const [hasMounted, setHasMounted] = React.useState(false);
  const [userAuth, setUserAuth] = React.useState();

  React.useEffect(() => {
    setHasMounted(true);
  }, []);


  React.useEffect(() => {

    const localBos = JSON.parse(localStorage.getItem('authUser'))
    if (user) {
      setUserAuth(user)
      // if (!user.username) {
      //   const createProfileCallable = firebase
      //     .functions.httpsCallable('createPublicProfile');
      //   console.log('am trecut si pe aici desi nu trebuia')
      //   createProfileCallable({
      //     username: user.displayName,
      //     email: user.email
      //   })
      // }
    } else if (localBos) {
      setUserAuth(localBos);
    }

  }, [user])

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          email
          siteUrl
        }
      }
    }
  `)
  if (!hasMounted) {
    return null;
  }
  return (
    <FirebaseContext.Provider value={{ user, userAuth, firebase, loading }}>
      <ThemeProvider theme={Theme}>
        <GlobalStyles />
        <>
          <Header siteTitle={data.site.siteMetadata.title} setUserAuth={setUserAuth} />
          <Section>{children}</Section>
           <Feedback />
          <Footer data={data.site.siteMetadata} />
          <CookieConsent
            location="bottom"
            buttonText="Accept"
            declineButtonText="Decline"
            // overlay
            cookieName="gatsby-gdpr-google-analytics"
            style={{ color: "#4e503b", fontSize: "13px", background: "#eafbfc", maxWidth: "100vw" }}
            buttonStyle={{
              color: "white", fontSize: "13px", borderRadius: "10px",
              background: "var(--blue-500)"
            }}
            expires={150}>
            Acest site folosește cookies pentru a asigura o experiență cât mai plăcută
          </CookieConsent>
        </>
      </ThemeProvider>
    </FirebaseContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
